export const EXCLUDED_STOP_IDS = ['92c2a532-9701-43e0-9f6d-c59b8241a550'];
